// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".configureBox[data-v-1fd68b98] {\n  height: 100%;\n  overflow-y: auto;\n  padding: 20px;\n}\n.configureBox .name[data-v-1fd68b98] {\n  font-weight: bold;\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
